import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg width="469" height="277" viewBox="0 0 469 277" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h469v277H0z" />
      <path fill="#50A1DA" d="M163 185.183h142.806V57.139H163z" />
      <path
        fill="#4A98D3"
        d="M266.74 185.183h6.57c7.412 0 13.42-5.997 13.42-13.394v-1.31h5.657c7.411 0 13.419-5.997 13.419-13.394v-3.342 31.44h-39.065z"
      />
      <text
        fill="#1251A0"
        fontFamily="Montserrat-SemiBold, Montserrat"
        fontSize="30"
        fontWeight="500"
        letterSpacing="-.005"
        transform="translate(163 47)"
      >
        <tspan x="44.108" y="186.409">
          +30
        </tspan>
      </text>
      <path
        fill="#1251A0"
        d="M163 192.777h142.806v-7.594H163zM163.08 87.659h142.726v-30.44H163.08z"
      />
      <path fill="#FAFAFA" d="M178.741 112.014h12.747V99.29H178.74z" />
      <path fill="#EAF2F9" d="M195.17 112.014h12.747V99.29h-12.746z" />
      <path fill="#FAFAFA" d="M211.6 112.014h12.747V99.29H211.6z" />
      <path fill="#EAF2F9" d="M228.03 112.014h12.746V99.29H228.03z" />
      <path fill="#FAFAFA" d="M244.46 112.014h12.746V99.29h-12.747z" />
      <path fill="#EAF2F9" d="M260.89 112.014h12.745V99.29H260.89z" />
      <path fill="#FAFAFA" d="M277.318 112.014h12.747V99.29h-12.747z" />
      <path fill="#EAF2F9" d="M178.741 127.367h12.747v-12.723H178.74z" />
      <path fill="#FAFAFA" d="M195.17 127.367h12.747v-12.723h-12.746z" />
      <path fill="#EAF2F9" d="M211.6 127.367h12.747v-12.723H211.6z" />
      <path fill="#FAFAFA" d="M228.03 127.367h12.746v-12.723H228.03z" />
      <path fill="#EAF2F9" d="M244.46 127.367h12.746v-12.723h-12.747z" />
      <path fill="#FAFAFA" d="M260.89 127.367h12.745v-12.723H260.89z" />
      <path fill="#EAF2F9" d="M277.318 127.367h12.747v-12.723h-12.747z" />
      <path fill="#FAFAFA" d="M178.741 142.72h12.747v-12.723H178.74z" />
      <path fill="#EAF2F9" d="M195.17 142.72h12.747v-12.723h-12.746z" />
      <path
        fill="#FAFAFA"
        d="M211.6 142.72h12.747v-12.723H211.6zM228.03 142.72h12.746v-12.723H228.03z"
      />
      <path fill="#EAF2F9" d="M244.46 142.72h12.746v-12.723h-12.747z" />
      <path
        fill="#FAFAFA"
        d="M260.89 142.72h12.745v-12.723H260.89zM277.318 142.72h12.747v-12.723h-12.747z"
      />
      <path fill="#EAF2F9" d="M178.741 158.073h12.747V145.35H178.74z" />
      <path fill="#FAFAFA" d="M195.17 158.073h12.747V145.35h-12.746z" />
      <path fill="#EAF2F9" d="M211.6 158.073h12.747V145.35H211.6z" />
      <path fill="#FAFAFA" d="M228.03 158.073h12.746V145.35H228.03z" />
      <path fill="#EAF2F9" d="M244.46 158.073h12.746V145.35h-12.747z" />
      <path fill="#FAFAFA" d="M260.89 158.073h12.745V145.35H260.89z" />
      <path fill="#EAF2F9" d="M277.318 158.073h12.747V145.35h-12.747z" />
      <path fill="#FAFAFA" d="M178.741 173.426h12.747v-12.723H178.74z" />
      <path fill="#EAF2F9" d="M195.17 173.426h12.747v-12.723h-12.746z" />
      <path fill="#FAFAFA" d="M211.6 173.426h12.747v-12.723H211.6z" />
      <path
        fill="#50A1DA"
        d="M185.098 66.894h19.605V47.326h-19.605zM264.183 66.894h19.606V47.326h-19.606z"
      />
      <g fill="#FF6969">
        <path d="M224.384 136.358c0 3.534-2.87 6.399-6.41 6.399-3.541 0-6.411-2.865-6.411-6.399 0-3.533 2.87-6.398 6.41-6.398s6.41 2.865 6.41 6.398" />
        <path d="M222.85 136.358a4.872 4.872 0 0 1-4.877 4.868 4.872 4.872 0 0 1-4.876-4.868 4.872 4.872 0 0 1 4.876-4.867 4.872 4.872 0 0 1 4.877 4.867" />
        <path d="M220.996 136.358a3.02 3.02 0 0 1-3.022 3.017 3.02 3.02 0 0 1-3.023-3.017 3.02 3.02 0 0 1 3.023-3.016 3.02 3.02 0 0 1 3.022 3.016" />
      </g>
    </g>
  </Svg>
)
